import api from '../utils/api'

/**
 * 权限管理 API
 */

// 获取所有可用角色
export const getRoles = (businessId) => {
  return api.get(`/api/businesses/${businessId}/roles`)
}

// 获取员工角色和权限
export const getEmployeeRole = (businessId, employeeId) => {
  console.log('=== 获取员工权限 API 调试信息 ===')
  console.log(
    'API 端点:',
    `/api/businesses/${businessId}/employees/${employeeId}/role`
  )
  console.log('请求方法: GET')

  return api
    .get(`/api/businesses/${businessId}/employees/${employeeId}/role`)
    .then((response) => {
      console.log('=== 获取员工权限 API 响应 ===')
      console.log('响应状态:', response.status)
      console.log('响应数据:', JSON.stringify(response.data, null, 2))
      if (response.data?.success && response.data?.data) {
        console.log('员工角色:', response.data.data.businessRole)
        console.log('自定义权限:', response.data.data.customPermissions)
        console.log('禁用权限:', response.data.data.deniedPermissions)
        console.log('最终权限:', response.data.data.permissions)
        console.log(
          '权限数量:',
          Array.isArray(response.data.data.permissions)
            ? response.data.data.permissions.length
            : 'N/A'
        )
      }
      console.log('================================')
      return response
    })
    .catch((error) => {
      console.error('=== 获取员工权限 API 错误 ===')
      console.error('错误状态:', error.response?.status)
      console.error('错误数据:', error.response?.data)
      console.error('============================')
      throw error
    })
}

// 更新员工角色
export const updateEmployeeRole = (businessId, employeeId, data) => {
  console.log('=== API 调用调试信息 ===')
  console.log(
    'API 端点:',
    `/api/businesses/${businessId}/employees/${employeeId}/role`
  )
  console.log('请求方法: PUT')
  console.log('请求数据:', JSON.stringify(data, null, 2))
  console.log('请求数据类型:', typeof data)
  console.log(
    'customPermissions 类型:',
    Array.isArray(data.customPermissions)
      ? '数组'
      : typeof data.customPermissions
  )
  console.log(
    'customPermissions 长度:',
    Array.isArray(data.customPermissions)
      ? data.customPermissions.length
      : 'N/A'
  )
  console.log(
    'deniedPermissions 类型:',
    Array.isArray(data.deniedPermissions)
      ? '数组'
      : typeof data.deniedPermissions
  )
  console.log(
    'deniedPermissions 长度:',
    Array.isArray(data.deniedPermissions)
      ? data.deniedPermissions.length
      : 'N/A'
  )

  return api
    .put(`/api/businesses/${businessId}/employees/${employeeId}/role`, data)
    .then((response) => {
      console.log('=== API 响应调试信息 ===')
      console.log('响应状态:', response.status)
      console.log('响应数据:', JSON.stringify(response.data, null, 2))
      console.log('========================')
      return response
    })
    .catch((error) => {
      console.error('=== API 错误调试信息 ===')
      console.error('错误状态:', error.response?.status)
      console.error('错误数据:', error.response?.data)
      console.error('错误信息:', error.message)
      console.error('======================')
      throw error
    })
}

// 批量更新员工角色
export const batchUpdateRoles = (businessId, updates) => {
  return api.post(
    `/api/businesses/${businessId}/employees/batch-update-roles`,
    {
      updates
    }
  )
}

// 更新员工账号状态
export const updateEmployeeStatus = (businessId, employeeId, accountStatus) => {
  return api.put(
    `/api/businesses/${businessId}/employees/${employeeId}/status`,
    { accountStatus }
  )
}

// 获取操作日志
export const getActivityLogs = (businessId, params = {}) => {
  return api.get(`/api/businesses/${businessId}/activity-logs`, { params })
}

// 获取特定员工的操作日志
export const getEmployeeActivityLogs = (
  businessId,
  employeeId,
  params = {}
) => {
  return api.get(
    `/api/businesses/${businessId}/employees/${employeeId}/activity-logs`,
    { params }
  )
}
